import React from "react";
import CommonDropdownInput from "../../components/common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../components/common/inputs/CommonFreeTextInput";

function MilesPointsLeaderboardSearchSection({
  search,
  setSearch,
  range,
  setRange,
}) {
  const filterOptions = ["All", "This Week", "This Month", "This Year"];
  return (
    <div className="w-full flex items-center justify-between">
      <div className="flex flex-1 max-w-[500px]">
        <CommonFreeTextInput
          placeholder="Search by travel agency name"
          value={search}
          onChange={(val) => setSearch(val)}
        />
      </div>
      <div className="flex flex-1 max-w-[150px]">
        <CommonDropdownInput
          value={range}
          onChange={(val) => {
            setRange(val);
          }}
          options={filterOptions}
        />
      </div>
    </div>
  );
}

export default MilesPointsLeaderboardSearchSection;
